// extracted by mini-css-extract-plugin
export var container = "_sf-0";
export var table = "_sf-2";
export var tableWrapper = "_sf-1";